import { Button, withStyles } from "@material-ui/core";

export const StyledButton = withStyles(() => ({
  root: {
    margin: "0.7rem 0",
    width: "100%",
    borderRadius: "1rem",
    padding: ".5rem",
    fontWeight: "600",
    background: "linear-gradient(to top, #0072ff, #00c6ff)",
    boxShadow: "none",
    "&:disabled": {
      color: "#777773",
      background: "#bdbdbd",
    },
  },
}))(Button);
